/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbEvaluationGridDto } from './FcbEvaluationGridDto';
import {
    FcbEvaluationGridDtoFromJSON,
    FcbEvaluationGridDtoFromJSONTyped,
    FcbEvaluationGridDtoToJSON,
} from './FcbEvaluationGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbEvaluationGridDtoPaginatedResults
 */
export interface FcbEvaluationGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbEvaluationGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbEvaluationGridDto>}
     * @memberof FcbEvaluationGridDtoPaginatedResults
     */
    results?: Array<FcbEvaluationGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbEvaluationGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbEvaluationGridDtoPaginatedResults interface.
 */
export function instanceOfFcbEvaluationGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbEvaluationGridDtoPaginatedResultsFromJSON(json: any): FcbEvaluationGridDtoPaginatedResults {
    return FcbEvaluationGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbEvaluationGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbEvaluationGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbEvaluationGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbEvaluationGridDtoPaginatedResultsToJSON(value?: FcbEvaluationGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbEvaluationGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

